import React from "react";
import { Button } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import DeleteRoundedIcon from "@material-ui/icons/DeleteRounded";
import { useIntl } from "react-intl";

const useStyles = makeStyles((theme) => ({
  button: theme.classes.mainButton,
}));

const CustomDeleteButton = (props) => {
  const { handleOpen } = props;
  const intl = useIntl();
  const classes = useStyles();

  return (
    <Button className={classes.button} startIcon={<DeleteRoundedIcon />} onClick={() => handleOpen(props?.record?.id)}>
      {intl.formatMessage({ id: "ra.action.delete" })}
    </Button>
  );
};

export default CustomDeleteButton;
